goog.provide("shadow.js.shim.module$src$svg$objects$calendar_svg$default");
shadow.js.shim.module$src$svg$objects$calendar_svg$default = shadow.js.shim.module$src$svg$objects$calendar_svg.default;
